import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styles from './Layout.module.css';

const navItems = [
  { path: '/', label: 'Dashboard' },
  { path: '/apps', label: 'Apps' },
  { path: '/tasks', label: 'Tasks' },
  { path: '/pipeline', label: 'Pipeline' },
  { path: '/prospects', label: 'Prospects' },
  { path: '/funnels', label: 'Funnels' },
  { path: '/revenue', label: 'Revenue' },
  { path: '/social', label: 'Social' },
  { path: '/bookings', label: 'Bookings' },
];

export default function Layout({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth();
  const location = useLocation();

  return (
    <div className={styles.layout}>
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <Link to="/" className={styles.logo}>
            Command Center
          </Link>
          <ul className={styles.navLinks}>
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`${styles.navLink} ${location.pathname === item.path ? styles.active : ''}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className={styles.userSection}>
            <span className={styles.userEmail}>{user?.email}</span>
            <button onClick={signOut} className={styles.signOutBtn}>
              Sign Out
            </button>
          </div>
        </div>
      </nav>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
